// Only set defaults if no prior cache exists
export const CACHE_PERSIST_DEFAULTS = {
    layouts: '',
    tempLayouts: '',
}

export const CACHE_ALWAYS_ON_LOAD = {
    isEditingLayouts: false,
    organizations: [], // leave an empty array so the query doesn't break.
    passwordRecoveryEmail: '',
    profile: null,
    error: null,
    accessoryDrawerState: null,
    dialogs: [], // Deprecated
    dialog: null,
    'dialogs({})': [], // Deprecated
    'dialogs({"type":"ALERT"})': [], // Deprecated
    'dialogs({"type":"SNACKBAR"})': [], // Deprecated
}
